import { IApplicationState } from '../../types/redux';
import { IDeveloperV2 } from '../../types/developerV2/developer';

export const getSellers = (state: IApplicationState) => (state.developerV2 as IDeveloperV2).sellers;
